module.exports = __webpack_public_path__ + "static/media/ic_empty_sampling.cd212039.svg";